import { WatchableValue } from "./watchable-value.js";
import { makeScheduler } from "./store-removal-strategies.js";
export class DerivedValueState {
    #dependencyUnsubscribes = [];
    #derive;
    #getDependency;
    #registeredDependencies = new Set();
    #value;
    #name;
    #unscheduleRemoval = () => { };
    constructor({ derive, removalSchedule, name }, removeFromStore, getDependency, defaultRemovalSchedule) {
        this.#derive = derive;
        this.#getDependency = getDependency;
        this.#name = name;
        const firstValue = this.#derive({
            get: (...args) => this.#getDependencyValue(...args),
            previousValue: undefined,
        });
        const { schedule: scheduleRemoval, unschedule: unscheduleRemoval } = makeScheduler(removalSchedule ?? defaultRemovalSchedule, () => {
            removeFromStore();
            this.#dependencyUnsubscribes.forEach((unsubscribeDependency) => {
                unsubscribeDependency();
            });
        });
        this.#unscheduleRemoval = unscheduleRemoval;
        this.#value = new WatchableValue(firstValue, () => {
            scheduleRemoval();
        }, name);
    }
    #deriveAgain() {
        this.#value.set(this.#derive({
            get: (...args) => this.#getDependencyValue(...args),
            previousValue: this.current,
        }));
    }
    #getDependencyValue(dependency) {
        const dependencyState = this.#getDependency(dependency);
        if (!this.#registeredDependencies.has(dependencyState)) {
            this.#registeredDependencies.add(dependencyState);
            this.#dependencyUnsubscribes.push(dependencyState.subscribe(() => {
                this.#deriveAgain();
            }));
        }
        return dependencyState.current;
    }
    get current() {
        return this.#value.current;
    }
    get name() {
        return this.#name;
    }
    subscribe(listener) {
        this.#unscheduleRemoval();
        return this.#value.subscribe(listener);
    }
}
//# sourceMappingURL=derived-value.js.map